import React from 'react';
export function ProcessTimeline() {
  const steps = [{
    title: 'Discover',
    description: 'Initial discovery call to understand your objectives, timeline, and budget.'
  }, {
    title: 'Design',
    description: 'Custom proposal with venue options, activities, and detailed pricing.'
  }, {
    title: 'Confirm',
    description: 'Finalize selections, secure venues, and lock in preferred dates.'
  }, {
    title: 'Plan',
    description: 'Detailed planning of logistics, activities, and special requirements.'
  }, {
    title: 'Execute',
    description: 'On-site management with dedicated bilingual concierge team.'
  }, {
    title: 'Debrief',
    description: 'Post-event analysis, feedback collection, and ROI measurement.'
  }];
  return <section className="py-16 bg-[#F4E8D0]/30" data-id="element-189">
      <div className="container mx-auto px-4 md:px-6" data-id="element-190">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-191">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-192">
            Our Process
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-193">
            A seamless journey from concept to execution.
          </p>
        </div>
        <div className="relative" data-id="element-194">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#0099A1]/30 transform -translate-x-1/2" data-id="element-195"></div>
          <div className="space-y-12 md:space-y-0" data-id="element-196">
            {steps.map((step, index) => <div key={index} className={`relative flex flex-col md:flex-row ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-197">
                <div className="md:w-1/2 mb-8 md:mb-24" data-id="element-198">
                  <div className={`md:max-w-md ${index % 2 === 0 ? 'md:ml-auto md:mr-8' : 'md:mr-auto md:ml-8'}`} data-id="element-199">
                    <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-200">
                      <h3 className="text-xl font-bold text-[#0099A1] mb-2" data-id="element-201">
                        {step.title}
                      </h3>
                      <p className="text-[#374047]/80" data-id="element-202">{step.description}</p>
                    </div>
                  </div>
                </div>
                {/* Timeline node */}
                <div className="absolute hidden md:flex left-1/2 transform -translate-x-1/2 items-center justify-center w-10 h-10 rounded-full bg-[#0099A1] text-white font-bold" data-id="element-203">
                  {index + 1}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}